var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cus-modal"},[_c('commodityProduct',{ref:"commodityProduct",on:{"on-ok":_vm.queryProduct,"on-cancel":_vm.queryCancel,"on-before-handle":_vm.onBeforeHandle}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }